import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CoverImageComponent, MinimalCatalogRecord as MinimalCatalogRecordForCoverImage} from '@aviary/components/cover-image/cover-image.component';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {isDefined} from '@aviary/store/common/typing.helpers';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {NgClass} from '@angular/common';

export type MinimalCatalogRecord = MinimalCatalogRecordForCoverImage & {
  id: number;
  title: string;
};

@Component({
  selector: 'px-combined-cover-title-detail',
  host: {
    class: 'flex flex-row justify-start items-center gap-x-2 w-full'
  },
  templateUrl: './combined-cover-title-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoverImageComponent, TruncateDirective, NamedRouterLinkDirective, FormatPipe, NgClass]
})
export class CombinedCoverTitleDetailComponent {
  protected readonly isDefined = isDefined;
  @Input({required: true}) public catalogRecord: MinimalCatalogRecord;
  @Input() public showCover: boolean = true;
  @Input() public detail1?: string;
  @Input() public detail2?: string;
  @Input() public date1Label?: string;
  @Input() public date1?: string;
  @Input() public date1Error?: boolean = false;
  @Input() public date2Label?: string;
  @Input() public date2?: string;
  @Input() public titleMaxLines?: number = 1;
  @Input() public detailTextSizeClasses?: string = 'text-body-medium md:text-body-small';
}
